/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from "lodash";
import {
  useContext,
  useEffect,
  useState
} from "react";
import { useHistory } from "react-router";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Pagination } from "../../components/Pagination";

import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import { useTranslation } from "react-i18next";
import { PerPage } from "../../components/PerPage";
import AuthApi from "../../context/AuthApi";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import { utcToLocal } from "../../utils/datetime";
import styles from "./Teams.module.scss";

dayjs.extend(utc);
const TeamsTable = ({
  isCampaign,
  perPage,
  setPerPage,
  selectedCampaign,
  ...props
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const Auth = useContext(AuthApi);
  const { addNotification } = useNotification();
  const [teamData, setTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [offset, setOffset] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const [columnName, setColumnName] = useState("u_fullname");
  const [sortOrder, setSortOrder] = useState("asc");
  const [uid] = useState(getLocalValue("uid"));
  const tableHeader = props.tableHeader;

  //ascending
  //descending

  // fetch from getSessionDetails api
  async function fetchData() {
    setIsLoading(true);
    const response = await apiRequest.get(
      `/api/getTeamCoacheeList?campaign_id=${selectedCampaign}&uid=${uid}&page=${offset}&limit=${perPage}&columnName=${columnName}&order=${sortOrder}`
    );

    if (response.status === 200) {
      const data = response.data.data;
      const teamsList = response.data.data.teams;
      setTeamData(teamsList);
      setTotalData(data.totalData);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  const handlePaginationChange = offset => {
    setOffset(offset.selected + 1);
  };

  const sortData = name => {
    setColumnName(name);
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
  };

  useEffect(() => {
    fetchData();
  }, [
    selectedCampaign,
    uid,
    offset,
    columnName,
    sortOrder,
    perPage,
    addNotification,
  ]);

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {tableHeader.map((tableHead, index) => (
                <TableCell
                  key={index}
                  style={{ width: tableHead.width }}
                  className={styles.tableHeadCell}
                  onClick={() => {
                    sortData(tableHead.name);
                  }}
                >
                  {tableHead.label}

                  {columnName === tableHead.name && sortOrder === "asc" && (
                    <span>
                      <KeyboardArrowUpIcon fontSize="small" />
                    </span>
                  )}
                  {columnName === tableHead.name && sortOrder === "desc" && (
                    <span>
                      <KeyboardArrowDownIcon fontSize="small" />
                    </span>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {teamData &&
              teamData.map((row, index) => (
                <TableRow
                  key={index}
                  className={styles.tableRow}
                  onClick={() => {
                    history.push(`/teams/details/${row.coachee_id}`);
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.u_fullname}
                  </TableCell>
                  <TableCell>{row.employee_id}</TableCell>
                  <TableCell>{row.department}</TableCell>
                  <TableCell>{row.sub_functional_unit}</TableCell>
                  <TableCell>
                    {row.lastsession && row.lastsession !== null && (
                      <span>
                        {utcToLocal(row.lastsession).format("DD MMM YYYY")}
                      </span>
                    )}
                  </TableCell>
                  <TableCell>
                    {row.upcomingsession && row.upcomingsession !== null && (
                      <span>
                        {utcToLocal(row.upcomingsession).format("DD MMM YYYY")}
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            {_.isEmpty(teamData) && (
              <TableRow style={{ borderBottom: "1px solid #eeeeee" }}>
                <TableCell style={{ borderBottom: 0 }} colSpan={5}>
                  {t("common.noRecordFound")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalData > perPage && (
        <div className={styles.footer}>
          <PerPage limit={perPage} setLimit={setPerPage} />
          <Pagination
            totalData={totalData}
            limit={perPage}
            offset={offset}
            handlePageClick={offset => {
              handlePaginationChange(offset);
            }}
          />
        </div>
      )}
    </>
  );
};
export default TeamsTable;
